import { convertFromRaw, EditorState } from 'draft-js';
import React from 'react';
import _ from 'lodash';
import { defineMessages, FormattedMessage } from 'react-intl';
import { emptyContentState } from '../../RichEditor/RichEditor';

const messages = defineMessages({
  required: { id: 'General.Required', defaultMessage: 'Required' },
});

export default values => {
  const errors = {};

  const editorState = EditorState.createWithContent(
    _.get(values, 'text')
      ? convertFromRaw(_.get(values, 'text'))
      : emptyContentState,
  );

  const editorStateContent = editorState && editorState.getCurrentContent();

  if (
    !editorStateContent ||
    !editorStateContent.hasText() ||
    !editorStateContent.getPlainText().trim().length
  ) {
    errors.text = <FormattedMessage {...messages.required} />;
  }

  return errors;
};
